export default function ServicesGrid() {
  const services = [
    {
      title: 'PVC Click Vloeren',
      subtitle: 'Klik PVC leggen',
      description: 'Click PVC plank en visgraat — snel gelegd, waterbestendig en geschikt voor vloerverwarming.',
      image: 'https://readdy.ai/api/search-image?query=Premium%20click%20PVC%20flooring%20herringbone%20pattern%20installed%20in%20modern%20living%20room%20warm%20oak%20look%20natural%20light%20clean%20minimalist%20interior%20photography%20high%20quality%20serene%20atmosphere',
      icon: 'ri-layout-grid-line',
    },
    {
      title: 'PVC Lijm Vloeren',
      subtitle: 'Lijm PVC leggen',
      description: 'Glue-down PVC voor badkamers, keukens en commerciële ruimtes — 100% waterdicht.',
      image: 'https://readdy.ai/api/search-image?query=Glue%20down%20PVC%20flooring%20waterproof%20installation%20in%20modern%20bathroom%20grey%20slate%20look%20clean%20minimalist%20interior%20photography%20high%20quality%20natural%20light',
      icon: 'ri-drop-line',
    },
    {
      title: 'Laminaat Vloeren',
      subtitle: 'Laminaat leggen',
      description: 'Breed plank en visgraat laminaat — authentieke houtlook met krassenbestendige toplaag.',
      image: 'https://readdy.ai/api/search-image?query=Wide%20plank%20laminate%20flooring%20light%20oak%20installed%20in%20modern%20open%20plan%20living%20space%20natural%20light%20clean%20minimalist%20interior%20photography%20high%20quality%20warm%20atmosphere',
      icon: 'ri-box-1-line',
    },
    {
      title: 'Gietvloeren',
      subtitle: 'PU & epoxy gietvloer',
      description: 'Naadloze gietvloeren in polyurethaan of epoxy — luxe uitstraling voor woning en kantoor.',
      image: 'https://readdy.ai/api/search-image?query=Seamless%20polyurethane%20poured%20floor%20gietvloer%20in%20modern%20minimalist%20apartment%20matte%20grey%20finish%20clean%20lines%20natural%20light%20interior%20photography%20high%20quality%20serene%20atmosphere',
      icon: 'ri-stack-line',
    },
  ];

  return (
    <section id="services" className="py-20 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-ink-900 mb-3 sm:mb-4">
            Onze PVC <span className="font-medium text-brass-600">diensten</span>
          </h2>
          <p className="text-base sm:text-lg text-ink-600 max-w-2xl mx-auto">
            Van PVC click en lijm vloeren tot laminaat en gietvloer — wij regelen het volledige traject voor u.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 lg:gap-6">
          {services.map((service, i) => (
            <a
              key={i}
              href="#offerte"
              className="group relative overflow-hidden rounded-xl sm:rounded-2xl aspect-[4/5] block cursor-pointer"
            >
              <img
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                src={service.image}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

              <div className="absolute top-3 sm:top-4 right-3 sm:right-4 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-brass-500/90 backdrop-blur-sm rounded-full">
                <i className={`${service.icon} text-white text-lg sm:text-xl`}></i>
              </div>

              <div className="absolute inset-0 p-4 sm:p-6 flex flex-col justify-end">
                <p className="text-xs sm:text-sm text-white/80 mb-1">{service.subtitle}</p>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-light text-white mb-2 sm:mb-3">{service.title}</h3>
                <p className="text-xs sm:text-sm text-white/70 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {service.description}
                </p>
                <span className="text-xs sm:text-sm text-white/60 group-hover:text-white/80 transition-colors whitespace-nowrap mt-2">
                  Bekijk meer &rarr;
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}